function _s(o, i, p, l) {
  void 0 === i && (i = 400),
    void 0 === l && (l = !1),
    (o.style.overflow = "hidden"),
    l && (o.style.display = "block");
  var n,
    t = window.getComputedStyle(o),
    s = parseFloat(t.getPropertyValue("height")),
    a = parseFloat(t.getPropertyValue("padding-top")),
    r = parseFloat(t.getPropertyValue("padding-bottom")),
    y = parseFloat(t.getPropertyValue("margin-top")),
    d = parseFloat(t.getPropertyValue("margin-bottom")),
    g = s / i,
    m = a / i,
    h = r / i,
    u = y / i,
    x = d / i;
  window.requestAnimationFrame(function t(e) {
    void 0 === n && (n = e);
    e -= n;
    l
      ? ((o.style.height = g * e + "px"),
        (o.style.paddingTop = m * e + "px"),
        (o.style.paddingBottom = h * e + "px"),
        (o.style.marginTop = u * e + "px"),
        (o.style.marginBottom = x * e + "px"))
      : ((o.style.height = s - g * e + "px"),
        (o.style.paddingTop = a - m * e + "px"),
        (o.style.paddingBottom = r - h * e + "px"),
        (o.style.marginTop = y - u * e + "px"),
        (o.style.marginBottom = d - x * e + "px")),
      i <= e
        ? ((o.style.height = ""),
          (o.style.paddingTop = ""),
          (o.style.paddingBottom = ""),
          (o.style.marginTop = ""),
          (o.style.marginBottom = ""),
          (o.style.overflow = ""),
          l || (o.style.display = "none"),
          "function" == typeof p && p())
        : window.requestAnimationFrame(t);
  });
}
(HTMLElement.prototype.slideToggle = function (t, e) {
  0 === this.clientHeight ? _s(this, t, e, !0) : _s(this, t, e);
}),
  (HTMLElement.prototype.slideUp = function (t, e) {
    _s(this, t, e);
  }),
  (HTMLElement.prototype.slideDown = function (t, e) {
    _s(this, t, e, !0);
  });

let PACK_SELECTION = {};

let packItems = [];

let total_quantity_global = false;

const passedIds = new Set();
for (let item of bundleData.bundle_products) {
  const variantId = item.variants[0].id;
  if (!passedIds.has(variantId)) {
    const newItem = {
      id: variantId,
      productId: item.id,
      handle: item.handle,
      title: item.title,
      quantity: 0,
      price: item.price,
      image: item.image,
    };
    packItems.push(newItem);
    passedIds.add(variantId);
  }
}

let lastScrollTop = 0;

class BundleSection extends HTMLElement {
  constructor() {
    super();


    this.querySelector('.product-image__header').addEventListener('click', function () {
      document.querySelector('.product-bundle__images').classList.toggle('active');
    });

    if (this.querySelector('.tabs-section__item-title')) {
      this.querySelectorAll(".faq-item-title").forEach((button) => {
        button.addEventListener("click", this.toggleFaqItem.bind(this));
      });
    }

    this.calculateShipping();


    this.querySelectorAll('.product-bundle__products-navigation--item').forEach((item) => {
      item.addEventListener('click', function (e) {
        let target = e.currentTarget;
        let index = target.getAttribute('data-filter');
        let items = document.querySelectorAll('.bundle-card');

        items.forEach((item) => {
          if (index == 'all') {
            item.classList.remove('hidden');
          } else {
            item.classList.add('hidden');
            if (item.getAttribute('data-filter-tag') == index) {
              item.classList.remove('hidden');
            }
          }
        });

        document.querySelectorAll('.product-bundle__products-navigation--item').forEach((item) => {
          item.classList.remove('active');
        });
        target.classList.add('active');
      });
    });


    document
      .querySelector(".product-bundle__submit")
      .addEventListener("click", this.submitBundle.bind(this));

    this.querySelector("subscription-option .sub-header")?.addEventListener(
      "click",
      this.toggleRecurring.bind(this)
    );

    this.updateRestAmmount();

    document
      .querySelector(".product-pack__subscription-current")
      ?.addEventListener("click", function (e) {
        document
          .querySelector(".product-pack__subscription-select")
          .classList.add("actif");
      });

    document
      .querySelectorAll(".product-pack__subscription-select-values label")
      ?.forEach(function (label) {
        label.addEventListener("click", function (e) {
          let selling_plan_id = e.currentTarget
            .getAttribute("for")
            .split("_")[2];


          let subscription_current = document.querySelector(
            ".product-pack__subscription-current-value"
          );

          let selling_plan_value = e.currentTarget.innerText;

          subscription_current.innerText = selling_plan_value;

          subscription_current.setAttribute(
            "data-current-recurring",
            label.dataset.indexSellingPlan
          );

          document
            .querySelector(".product-pack__subscription-select")
            .classList.remove("actif");
        });
      });

    window.addEventListener("DOMContentLoaded", function () {
      document.querySelector("quantity-inputs").udateProgressBar(0);

    });



    this.querySelector(".product-pack__subscription-toggle")?.addEventListener(
      "click",
      function (e) {
        setTimeout(() => {
          document
            .querySelector("subscription-option")
            .classList.toggle("actif-toggle");
        }, 240);

        document
          .querySelector("subscription-option")
          .classList.toggle("actif-toggle-2");
        document.querySelector(".recuring-option__content").style.height =
          document.querySelector(".recuring-option__content").style.height ===
            "0px"
            ? `${document.querySelector(".recuring-option__content").scrollHeight
            }px`
            : "0";
      }
    );
  }

  toggleFaqItem(e) {
    e.currentTarget
      .querySelector(".faq-close")
      .classList.toggle("faq-display-none");

    e.currentTarget.parentNode.classList.toggle("faq-item-active");

    const item = e.currentTarget.parentNode.querySelector(".faq-item-text");
    console.log(item);

    item.slideToggle("250");
  }


  calculateShipping() {
    if (this.querySelector(".sidecart-form__icon")) {
      // calculate shipping date from today + shipping delay exclude weekends
      let shipping_date = new Date(new Date().getTime());

      let shipping_delay = parseInt(
        this.querySelector(".sidecart-form__icon").getAttribute(
          "data-shipping-delay"
        )
      );
      if (shipping_delay == null) {
        shipping_delay = parseInt(
          this.querySelector(".cart-form__icon").getAttribute(
            "data-shipping-delay"
          )
        );
      }

      for (var i = 0; i < shipping_delay; i++) {
        shipping_date.setDate(shipping_date.getDate() + 1);
        if (shipping_date.getDay() == 6) {
          shipping_date.setDate(shipping_date.getDate() + 2);
        }
        if (shipping_date.getDay() == 0) {
          shipping_date.setDate(shipping_date.getDate() + 1);
        }
      }

      // get french date format day month year
      let shipping_date_format = shipping_date.toLocaleDateString("fr-FR", {
        weekday: "short",
        day: "numeric",
        month: "long",
      });

      for (
        let i = 0;
        i < document.querySelectorAll(".sidecart-form__icon").length;
        i++
      ) {
        let html = document.querySelectorAll(".sidecart-form__icon")[i]
          .innerHTML;
        if (html.indexOf("[date]") > -1) {
          document.querySelectorAll(".sidecart-form__icon")[i].innerHTML =
            html.replace("[date]", shipping_date_format);
        }
      }

      for (
        let i = 0;
        i < document.querySelectorAll(".cart-form__icon").length;
        i++
      ) {
        let html = document.querySelectorAll(".cart-form__icon")[i].innerHTML;
        if (html.indexOf("[date]") > -1) {
          if (document.querySelector(".cart-form__icon")) {
            document.querySelectorAll(".cart-form__icon")[i].innerHTML =
              html.replace("[date]", shipping_date_format);
          }
        }
      }
    }
  }

  updateRestAmmount() {
    // let container = document.querySelector(".reassurance .rest");
    // let freeShipping = this.dataset.freeShippingAmmount;
    // let cartAmmount = this.dataset.cartAmmount / 100;
    // let currentSachetsAmmount = Number(this.dataset.totalCurrentSachets).toFixed(2);
    // let currentSachetsCart = document.querySelector('[data-sachets-total-price') ? Number(document.querySelector('[data-sachets-total-price]').dataset.sachetsTotalPrice / 100).toFixed(2) : 0;
    // let restAmmount = freeShipping - ((cartAmmount - currentSachetsCart) + currentSachetsAmmount);

  }

  toggleRecurring() {
    // toggle active class on subscription option
    const subscriptionOption = this.querySelector("subscription-option");
    subscriptionOption.classList.toggle("actif");
    document.querySelector("quantity-inputs").updateSelectionContent();
  }

  async submitBundle(e) {
    let target = e.currentTarget;
    if (target.classList.contains("active")) {
      let selections_items = [];

      let packs__quantity = 0;

      for (const item of PACK_SELECTION.pack_items) {
        packs__quantity += item.quantity;
      }

      if (packs__quantity != 0) {
        for (const item of PACK_SELECTION.pack_items) {
          if (item.quantity > 0) {
            selections_items.push({
              id: item.id,
              quantity: item.quantity
            });
          }
        }


        let items = PACK_SELECTION.pack_items.map((item) => {
          return {
            id: item.id,
            quantity: item.quantity,
          };
        });

        const updates = items.reduce((acc, item) => {
          acc[item.id] = item.quantity;
          return acc;
        }, {});


        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: items
          }),
        })
          .then(response => response.json())
          .then(data => {
            console.log('Success:', data);
            document.querySelector('side-cart').renderCart();
            document.querySelector('side-cart').openCart();
            jouerSon();
          })
          .catch((error) => {
            console.error('Error:', error);
          });


      }
    }
  }
}

customElements.define("bundle-section", BundleSection);

window.addEventListener("load", function () {
  document.documentElement.style.setProperty(
    "--vh",
    `${window.innerHeight / 100}px`
  );
});
window.addEventListener("resize", function () {
  document.documentElement.style.setProperty(
    "--vh",
    `${window.innerHeight / 100}px`
  );
});

class VariantItem extends HTMLElement {
  constructor() {
    super();
    this.updatePackContent();
  }

  updatePackContent() {
    PACK_SELECTION = {
      pack_items: PACK_SELECTION.pack_items
        ? PACK_SELECTION.pack_items
        : packItems,
    };

    if (PACK_SELECTION.pack_items) {
      let total = 0;
      for (const item of PACK_SELECTION.pack_items) {
        total += item.quantity;
      }
    }

  }
}

customElements.define("variant-item", VariantItem);

let selection = [];
let current_reduction = 0;

(function initFirstCurrentSelection() {
  const inputs = document.querySelectorAll('quantity-inputs [name="quantity"]');

  for (const input of inputs) {
    selection.push({
      id: input.dataset.handle,
      quantity: parseInt(input.value),
      price: input.dataset.price,
      image: input.dataset.image,
      color: input.dataset.colorCounter,
    });
  }
})();

class QuantityInputs extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[name="quantity"]');
    this.addEventListener("click", this.changeQuantity.bind(this));
    this.addEventListener("updateContent", this.changeQuantity.bind(this));
    this.querySelector(".product--quantity__init").addEventListener(
      "click",
      function () {
        this.querySelector('[data-action="increment"]').click();
        this.querySelector(".product--quantity__init").classList.add("hidden");
      }.bind(this)
    );
  }

  changeQuantity(event) {
    let target = event.target;
    let total = 0;

    for (const item of PACK_SELECTION.pack_items) {
      total += item.quantity;
    }

    const value = parseInt(this.input.value);

    if (target.classList.contains("quantity-input__btn")) {
      if (target.dataset.action === "increment") {
        target
          .closest("quantity-inputs")
          .querySelector('[data-action="decrement"]')
          .removeAttribute("disabled");
        this.input.value = parseInt(value) + 1;
        this.querySelector(".product--quantity__init").classList.add("hidden");

        if (this.input.value == this.input.max) {
          this.parentNode.classList.add("out-of-stock-dinamique");
        }
      } else if (target.dataset.action === "decrement") {
        this.parentNode.classList.remove("out-of-stock-dinamique");
        document
          .querySelectorAll('[data-action="increment"]')
          .forEach((elem) => {
            elem.setAttribute("disabled", "false");
          });
        if (value > 0) {
          this.input.value = parseInt(value) - 1;
          if (this.input.value == 0) {
            target.setAttribute("disabled", "disabled");
          }
        } else {
          this.querySelector(".product--quantity__init").classList.remove(
            "hidden"
          );
        }
      }

      let currentItem = selection.filter(
        (item) => item.id === this.input.dataset.handle
      );

      if (currentItem.length > 0) {
        currentItem[0].quantity = parseInt(this.input.value);
      } else {
        selection.push({
          id: this.input.dataset.handle,
          quantity: parseInt(this.input.value),
          image: this.input.dataset.image,
          color: this.input.dataset.colorCounter,
          price: this.input.dataset.price,
        });
      }

      selection = selection.filter((item) => item.quantity > 0);
    }

    this.udateProgressBar(Number(0));
  }

  udateProgressBar(nb) {
    let total_sachets = 0;
    let total_sachets_global = 0;
    if (this.input.value == 0) {
      this.querySelector(".product--quantity__init").classList.remove("hidden");
    }

    let quantity_inputs = document.querySelectorAll(
      'quantity-inputs [name="quantity"][data-handle]'
    );

    for (const input of quantity_inputs) {
      total_sachets += parseInt(input.value);
      total_sachets_global = total_sachets;
    }


    this.updateSelectionContent(total_sachets);
    let total_price = 0;

    if (total_sachets == 0) {
      document.querySelector('.product-bundle__submit').classList.remove('active');
    } else {
      document.querySelector('.product-bundle__submit').classList.add('active');
    }


    for (const item of PACK_SELECTION.pack_items) {
      if (item.quantity != 0) {
        total_price += item.price * item.quantity;
      }
    }


    total_sachets = total_sachets + Number(nb);

    let progress_1 = document.querySelector(
      "bundle-section .product-form__progress--bar-item-1[data-reduction-step]"
    );
    let progress_2 = document.querySelector(
      "bundle-section .product-form__progress--bar-item-2[data-reduction-step]"
    );
    let progress_3 = document.querySelector(
      "bundle-section .product-form__progress--bar-item-3[data-reduction-step]"
    );

    let totalQuantity = Number(document.querySelector('[data-sachet-in-cart-bundle]').dataset.sachetInCartBundle) + total_sachets;
    let totalPrice = (parseInt(document.querySelector('side-cart .sidecart__progress[data-cart-count]').dataset.cartCount) / 100) + (total_price * 100);;

    if (totalQuantity <= parseInt(progress_1.dataset.reductionStep)) {
      let multiply = 100 / Number(progress_1.dataset.reductionStep);
      document.querySelector('bundle-section .product-form__progress--bar-item-1[data-reduction-step] .progress__fill .fill__content').style.width = `${multiply * totalQuantity}%`;
      document.querySelector('bundle-section .product-form__progress--bar-item-3[data-reduction-step] .progress__fill .fill__content').style.width = `0%`;
      if (totalQuantity == Number(document.querySelector('bundle-section .product-form__progress--bar-item-1[data-reduction-step]').dataset.reductionStep)) {
        progress_1.classList.add('active');
      } else {
        document.querySelector('bundle-section .product-form__progress--bar-item-1[data-reduction-step] ').classList.remove('active');
      }
    }

    console.log(totalPrice, parseInt(document.querySelector('bundle-section .product-form__progress--bar-item-2[data-reduction-step]').dataset.reductionStep) * 100);

    if (totalPrice >= 4000) {
      let currentAmmout = totalPrice - 4000;
      let multiply = 100 / 2000;
      document.querySelector('bundle-section .product-form__progress--bar-item-2[data-reduction-step] .progress__fill .fill__content').style.width = `${multiply * currentAmmout}%`;
      if (totalPrice >= (parseInt(document.querySelector('bundle-section .product-form__progress--bar-item-2[data-reduction-step]').dataset.reductionStep) * 100)) {
        document.querySelector('bundle-section .product-form__progress--bar-item-2[data-reduction-step]').classList.add('active');
        document.querySelector('bundle-section .product-form__progress--bar-item-2[data-reduction-step] .progress__fill .fill__content').style.width = `100%`;
      }
    }
    else {
      document.querySelector('bundle-section .product-form__progress--bar-item-2[data-reduction-step] .progress__fill .fill__content').style.width = `0%`;
      document.querySelector('bundle-section .product-form__progress--bar-item-2[data-reduction-step] ').classList.remove('active');
    }

    let price_quantity = document.querySelector('bundle-section .product-form__progress--bar-item-2[data-reduction-step]').dataset.reductionStep / 10;

    if (totalQuantity == parseInt(price_quantity) || totalQuantity >= parseInt(price_quantity) && totalQuantity <= parseInt(document.querySelector('bundle-section .product-form__progress--bar-item-3[data-reduction-step]').dataset.reductionStep)) {
      let multiply = 100 / (Number(document.querySelector('bundle-section .product-form__progress--bar-item-3[data-reduction-step]').dataset.reductionStep) - Number(price_quantity));
      document.querySelector('bundle-section .product-form__progress--bar-item-3[data-reduction-step] .progress__fill .fill__content').style.width = `${multiply * (totalQuantity - (Number(price_quantity)))}%`;
      if (totalQuantity >= Number(document.querySelector('bundle-section .product-form__progress--bar-item-3[data-reduction-step]').dataset.reductionStep)) {
        document.querySelector('bundle-section .product-form__progress--bar-item-3[data-reduction-step]').classList.add('active');
        document.querySelector('bundle-section .product-form__progress--bar-item-3[data-reduction-step] .progress__fill .fill__content').style.width = `100%`;
      } else {
        document.querySelector('bundle-section .product-form__progress--bar-item-3[data-reduction-step] ').classList.remove('active');
      }
    }

    if (totalQuantity > parseInt(document.querySelector('bundle-section .product-form__progress--bar-item-1[data-reduction-step]').dataset.reductionStep)) {
      document.querySelector('bundle-section .product-form__progress--bar-item-1[data-reduction-step]').classList.add('active');
      document.querySelector('bundle-section .product-form__progress--bar-item-1[data-reduction-step] .progress__fill .fill__content').style.width = `100%`;
    }
    if (totalPrice >= (parseInt(document.querySelector('bundle-section .product-form__progress--bar-item-2[data-reduction-step]').dataset.reductionStep) * 100)) {
      document.querySelector('bundle-section .product-form__progress--bar-item-2[data-reduction-step]').classList.add('active');
      document.querySelector('bundle-section .product-form__progress--bar-item-2[data-reduction-step] .progress__fill .fill__content').style.width = `100%`;
    }

    if (totalQuantity >= Number(document.querySelector('bundle-section .product-form__progress--bar-item-3[data-reduction-step]').dataset.reductionStep)) {
      document.querySelector('bundle-section .product-form__progress--bar-item-3[data-reduction-step]').classList.add('active');
      document.querySelector('bundle-section .product-form__progress--bar-item-3[data-reduction-step] .progress__fill .fill__content').style.width = `100%`;
      if (!document.querySelector('[date-free-in-cart]')) {
      }
    }

    if (total_sachets >= Number(progress_3.dataset.reductionStep)) {
      current_reduction = 0
    }


  }

  updateSelectionContent(total_sachets) {
    const quantity_inputs = document.querySelectorAll("quantity-inputs");

    let total = 0;
    let total_price = 0;

    for (const input of quantity_inputs) {
      for (let item of PACK_SELECTION.pack_items) {

        // Update the quantity of each smoothie in the pack selection object
        if (item.handle === input.querySelector("input").dataset.handle) {
          item.quantity = parseInt(input.querySelector("input").value);
          total += item.quantity;
          total_price += item.price * item.quantity;
        }
      }
    }

    document.querySelectorAll('.bundle-section__value').forEach((item) => {
      item.textContent = total;
    });

    let good_reduction = 0;

    if (current_reduction == 0) {
      good_reduction = 1;
    } else {
      good_reduction = 1 - current_reduction / 100;
    }

    total_price = total_price * good_reduction;
    let total_price_compared = total_price;
    document.querySelector(
      ".product-bundle__submit [data-total-price]"
    ).textContent = total_price.toFixed(2) + "€";

    document.querySelector('bundle-section').dataset.totalCurrentSachets = total_price.toFixed(2);

    if (total_price_compared != 0 && total_price_compared != total_price) {
      document.querySelector(
        ".product-bundle__submit [data-compared-price]"
      ).textContent = total_price_compared.toFixed(2) + "€";
      document
        .querySelector(".product-bundle__submit [data-compared-price]")
        .classList.remove("hidden");
      document
        .querySelector(".product-bundle__submit .short-title")
        .classList.add("hidden");
    } else {
      document.querySelector(
        ".product-bundle__submit [data-compared-price]"
      ).textContent = "";
      document
        .querySelector(".product-bundle__submit [data-compared-price]")
        .classList.add("hidden");
      document
        .querySelector(".product-bundle__submit .short-title")
        .classList.remove("hidden");
    }
    if (total == 0) {
    } else {
    }

    let index = 0;
    let content_updated = "";
    for (const item of PACK_SELECTION.pack_items) {
      if (item.quantity > 0) {
        // ${item.title.replace('Sachet ', '') and replace first letter width capital letter
        if (index == 0) {
          content_updated += ` ${item.title.replace("Sachet ", "").charAt(0).toUpperCase() +
            item.title.replace("Sachet ", "").slice(1)
            } (${item.quantity})`;
        } else {
          content_updated += `, ${item.title.replace("Sachet ", "").charAt(0).toUpperCase() +
            item.title.replace("Sachet ", "").slice(1)
            } (${item.quantity})`;
        }
        index++;
      }
    }

    if (total == 0) {
      document
        .querySelector(".product-bundle__details-products")
        .classList.add("hidden");
    } else {
      document
        .querySelector(".product-bundle__details-products")
        .classList.remove("hidden");
    }

    document.querySelector(
      ".product-bundle__details-products p span"
    ).textContent = content_updated;

    let index_image = 0;


    for (const item of selection) {
      if (item.quantity > 0) {
        document.querySelector(
          `[data-image-index="${index_image}"] .counter`
        ).style.background = item.color;
        document.querySelector(`[data-image-index="${index_image}"] img`).src =
          item.image;
        document
          .querySelector(`[data-image-index="${index_image}"]`)
          .classList.add("active");
        document.querySelector(
          `[data-image-index="${index_image}"] .counter`
        ).textContent = "x" + item.quantity;

        index_image++;
      }

    }
    const inputs = document.querySelectorAll(
      'quantity-inputs [name="quantity"]'
    );

    inputs.forEach((input, i) => {
      if (i >= index_image) {
        document.querySelector('[data-image-index="' + index_image + '"]').src =
          "";
        document
          .querySelector('[data-image-index="' + index_image + '"]')
          .classList.remove("active");
        document.querySelector(
          '[data-image-index="' + index_image + '"] .counter'
        ).textContent = "";

      }
    });
  }
}

if (customElements.get("quantity-inputs") === undefined) {
  customElements.define("quantity-inputs", QuantityInputs);
}

const disabledLinks = (urls, attr, setAttr) => {
  [...urls].forEach((url) => {
    url.setAttribute(attr, setAttr);
  });
};

const blockedLinks = (down) => {
  const allLinks = document.querySelectorAll(".url-card");
  down
    ? disabledLinks(allLinks, "disabled", "disabled")
    : disabledLinks(allLinks, "disabled", "");
};
